<aside class="theme-panel" aria-labelledby="theme-panel-title">
  <header class="theme-panel-header">
    <div>
      <span class="theme-panel-eyebrow">Personalização</span>
      <h2 id="theme-panel-title">Aparência</h2>
      <p>Escolha como o sistema deve ser exibido.</p>
    </div>

    <button type="button" class="theme-panel-close" aria-label="Fechar" (click)="close()">
      <i-lucide name="x" size="20"></i-lucide>
    </button>
  </header>

  <div class="theme-panel-content">
    <section class="theme-panel-section" aria-labelledby="theme-mode-title">
      <div class="theme-panel-section-heading">
        <h3 id="theme-mode-title">Modo</h3>
        <span>{{ selectedMode === 'light' ? 'Claro' : 'Escuro' }}</span>
      </div>

      <div class="theme-mode-options">
        <button
          type="button"
          class="theme-mode-option"
          [class.selected]="selectedMode === 'light'"
          [attr.aria-pressed]="selectedMode === 'light'"
          (click)="selectMode('light')">
          <span class="theme-mode-icon light">
            <i-lucide name="sun" size="21"></i-lucide>
          </span>
          <span>
            <strong>Claro</strong>
            <small>Fundo branco</small>
          </span>
          <i-lucide *ngIf="selectedMode === 'light'" class="theme-selected-icon" name="circle-check" size="18"></i-lucide>
        </button>

        <button
          type="button"
          class="theme-mode-option"
          [class.selected]="selectedMode === 'dark'"
          [attr.aria-pressed]="selectedMode === 'dark'"
          (click)="selectMode('dark')">
          <span class="theme-mode-icon dark">
            <i-lucide name="moon" size="21"></i-lucide>
          </span>
          <span>
            <strong>Escuro</strong>
            <small>Menos luminosidade</small>
          </span>
          <i-lucide *ngIf="selectedMode === 'dark'" class="theme-selected-icon" name="circle-check" size="18"></i-lucide>
        </button>
      </div>
    </section>

    <section class="theme-panel-section" aria-labelledby="theme-color-title">
      <div class="theme-panel-section-heading">
        <h3 id="theme-color-title">Cor do sistema</h3>
        <span>Aplicação imediata</span>
      </div>

      <div class="theme-color-options">
        <button
          *ngFor="let theme of themes"
          type="button"
          class="theme-color-option"
          [class.selected]="selectedTheme === theme.value"
          [attr.aria-pressed]="selectedTheme === theme.value"
          (click)="selectTheme(theme.value)">
          <span class="theme-color-swatch" [style.background]="theme.color">
            <i-lucide *ngIf="selectedTheme === theme.value" name="check" size="17"></i-lucide>
          </span>
          <span>{{ theme.label }}</span>
        </button>
      </div>
    </section>
  </div>

  <footer class="theme-panel-footer">
    <button type="button" class="btn theme-reset-button" (click)="restoreDefaults()">
      Restaurar padrão
    </button>
    <button type="button" class="btn theme-done-button" (click)="close()">
      Concluído
    </button>
  </footer>
</aside>
